





















import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';

export default {
  name: 'Cancellation',

  components: {
    AppButtonNew,
  },

  data() {
    return {
      inTheProcessOfClosing: false,
    };
  },

  methods: {
    startCancel() {
      this.inTheProcessOfClosing = true;
    },
    stopCancel() {
      this.inTheProcessOfClosing = false;
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/components/cancellation/Cancellation.vue